export const formatAddress = (address, fm) => {
  if (!address) {
    return fm({ id: 'orderView.items.none' });
  }

  const { address1: line1 = '', address2: line2 = '', city = '', state = '', zip = '' } = address || {};

  return line1 ? (
    <pre>
      {`${line1 || ''}
${line2 || ''}
${city ? `${city}, ` : ''}${state ? `${state} ` : ''}${zip || ''}`.replace(/\n+/g, '\n')}
    </pre>
  ) : (
    fm({ id: 'orderView.items.none' })
  );
};

export const formatContact = (contact, fm) => {
  if (!contact) {
    return fm({ id: 'orderView.items.none' });
  }

  const {
    companyName: company = '',
    firstName: first = '',
    middleName: middle = '',
    lastName: last = '',
    address1: line1 = '',
    address2: line2 = '',
    city = '',
    state = '',
    zip = '',
    phone = '',
    email = '',
  } = contact || {};

  return (
    <pre>
      {`${company || `${first ? `${first} ` : ''}${middle ? `${middle} ` : ''}${last || ''}`}
${line1 || ''}
${line2 || ''}
${city ? `${city}, ` : ''}${state ? `${state} ` : ''}${zip || ''}
${phone || ''}
${email || ''}`.replace(/\n+/g, '\n')}
    </pre>
  );
};
